module.exports = __webpack_public_path__ + "media/images/cleaning/pro2-24dd742cbc8bead88bc802de03069d21.jpg";